/* Extracted from snippets/design-polish.liquid on 2026-08-15.
   Was inline in every document that renders this file; now fetched once and
   cached. Deferred, so it runs after the DOM is parsed rather than at its old
   position — safer for the DOM queries inside, not riskier.
   No Liquid in here, which is why it could move at all. */

/* Section Entrance Observer — reveals sections as they scroll into view */
  (function () {
    if (window.innerWidth < 900) return;

    function initObserver() {
      var sections = document.querySelectorAll(
        '.shopify-section:not(.shopify-section-group-header-group):not(.shopify-section-group-footer-group) > *:first-child'
      );
      if (!sections.length) return;

      var sectionIO = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('dp-visible');
              sectionIO.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.08, rootMargin: '0px 0px -60px 0px' }
      );

      sections.forEach(function (section, i) {
        /* Skip the first section (hero) — it should be immediately visible. Also skip animations in theme editor to avoid loading bugs. */
        if (i === 0 || (window.Shopify && window.Shopify.designMode)) {
          section.classList.add('dp-visible');
          return;
        }
        sectionIO.observe(section);
      });
    }

    document.addEventListener('DOMContentLoaded', initObserver);

    // Support for Shopify Theme Editor (design mode) to prevent sections becoming invisible during editing
    document.addEventListener('shopify:section:load', function (event) {
      var firstChild = event.target.querySelector(':scope > *:first-child');
      if (firstChild) {
        firstChild.classList.add('dp-visible');
      }
    });
  })();
